import { AddressInfo } from "@schoolbelle/api/address-input";

export class PurchaseModel {
    paymentType:'virtualAccount'|'bankTransfer'|'creditCard'
    paymentCurrency:string
    taxRate:number
    buyerInfo:{
        groupType:'school.kindergarten'|'school.elementary'|'school.middle'|'school.high'|'school.combined'
        groupName:string
        groupAddress :AddressInfo
        // groupSize : 'xs'|'sm'|'md'|'lg'|'xl'|'xxl'
        groupHeadName :string
        accountId:string
    }
    personInCharge:{
        personInChargeName? :string
        personInChargeTel? :string
        personInChargeEmail :string
    }
    accountant?: {
        accountantEmail :string
    } 
    products: {
        productId:number
        amount:number
        quantity?:number
        startsAt?:number
        expiresAt?:number

    }[]

    message:string
}